import React from "react";
import PropTypes from "prop-types";
import { DataTable, TableHeader, TableBody, TableRow, TableColumn } from "react-md";
import MCard from "components/Shared/MCard.tsx";
import { dateTimeToStringWithDOW } from "components/Shared/Formatters";

class CaseReturns extends React.Component {
    render() {
        const { caseReturns, className } = this.props;

        if (caseReturns.length === 0) {
            return null;
        }

        const rows = caseReturns.map(({ id, author, body, created }) => (
            <TableRow key={id}>
                <TableColumn>
                    <div>{author}</div>
                    <div className="indent">{body}</div>
                </TableColumn>
                <TableColumn>{dateTimeToStringWithDOW(created)}</TableColumn>
            </TableRow>
        ));

        return (
            <MCard
                title="Case Returns"
                className={className}
                fields={[{
                    key: "case-returns-card",
                    control:
                        <DataTable
                            baseId="case-returns-table"
                            selectableRows={false}
                        >
                            <TableHeader>
                                <TableRow>
                                    <TableColumn>Author</TableColumn>
                                    <TableColumn>Returned</TableColumn>
                                </TableRow>
                            </TableHeader>
                            <TableBody>{rows}</TableBody>
                        </DataTable>
                }]}
            />
        );
    }
}

CaseReturns.defaultProps = {
    caseReturns: [],
};

CaseReturns.propTypes = {
    caseReturns: PropTypes.array,
    className: PropTypes.string,
};

export default CaseReturns;